'use strict';

var React = require('react');

function SvgPlusCircleOutline(props) {
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z" }),
        React.createElement("path", { d: "M15 11h-2V9a1 1 0 00-2 0v2H9a1 1 0 000 2h2v2a1 1 0 002 0v-2h2a1 1 0 000-2z" })));
}

module.exports = SvgPlusCircleOutline;
